/*
 * @Author: ningbo.kang
 * @Date: 2019-09-29 12:08:41
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2020-11-02 14:02:40
 * @FilePath: /template/src/store/mutation-types.js
 * @Description: 描述
 */
export const ACCESS_TOKEN = 'Access-Token';
export const SIDEBAR_TYPE = 'SIDEBAR_TYPE';
export const DEFAULT_THEME = 'DEFAULT_THEME';
export const DEFAULT_LAYOUT_MODE = 'DEFAULT_LAYOUT_MODE';
export const DEFAULT_COLOR = 'DEFAULT_COLOR';
export const DEFAULT_COLOR_WEAK = 'DEFAULT_COLOR_WEAK';
export const DEFAULT_FIXED_HEADER = 'DEFAULT_FIXED_HEADER';
export const DEFAULT_FIXED_SIDEMENU = 'DEFAULT_FIXED_SIDEMENU';
export const DEFAULT_FIXED_HEADER_HIDDEN = 'DEFAULT_FIXED_HEADER_HIDDEN';
export const DEFAULT_CONTENT_WIDTH_TYPE = 'DEFAULT_CONTENT_WIDTH_TYPE';
export const DEFAULT_MULTI_TAB = 'DEFAULT_MULTI_TAB';
export const DEFAULT_SEARCH_MENU = 'DEFAULT_SEARCH_MENU';
export const DEFAULT_PERMISSION = 'DEFAULT_PERMISSION';
export const DEFAULT_NAV_MENU = 'DEFAULT_NAV_MENU';
export const DEFAULT_SHOW_CHANGE_COLOR = 'DEFAULT_SHOW_CHANGE_COLOR';
export const DEFAULT_SHOW_CHANGE_LANGUAGE = 'DEFAULT_SHOW_CHANGE_LANGUAGE';
export const DEFAULT_SHOW_TIPS = 'DEFAULT_SHOW_TIPS';
export const APP_LANGUAGE = 'app_language';

export const CONTENT_WIDTH_TYPE = {
  Fluid: 'Fluid',
  Fixed: 'Fixed',
};
